export default {

  HOME_PAGE: {
    HP_ZONE_B: 'HP_ZONE_B',
    HP_ZONE_C: 'HP_ZONE_C',
    HP_ZONE_D: 'HP_ZONE_D',
    HP_ZONE_E: 'HP_ZONE_E',
  },

  SEARCH_PAGE: {
    SEARCH_ZONE_A: 'SEARCH_ZONE_A',
  },

  BROWSE_PAGE: {
    BROWSE_ZONE_A: 'BROWSE_ZONE_A',
  },

  CAT_SPLASH_PAGE: {
    C2FLEX_ZONE_A: 'C2FLEX_ZONE_A',
    C2FLEX_ZONE_B: 'C2FLEX_ZONE_B',
    C2FLEX_ZONE_C: 'C2FLEX_ZONE_C',
    C2FLEX_ZONE_D: 'C2FLEX_ZONE_D',
  },

  ZSR_PAGE: {
    ZSR_ZONE_B: 'ZSR_ZONE_B',
  },

  PDP_PAGE: {
    PDP_ZONE_A: 'PDP_ZONE_A',
    PDP_ZONE_B: 'PDP_ZONE_B',
    PDP_ZONE_C: 'PDP_ZONE_C',
  },

  ATB_PAGE: {
    ATBPage_ZONE_C: 'ATBPage_ZONE_C',
    ATBPage_ZONE_E: 'ATBPage_ZONE_E',
  },

  BAG_PAGE: {
    SB_ZONE_A: 'SB_ZONE_A',
    SB_ZONE_B: 'SB_ZONE_B',
    SB_ZONE_C: 'SB_ZONE_C',
  },

  MY_ACCOUNT_PAGE: {
    MAP_ZONE_A: 'MAP_ZONE_A',
  },


  RETURN_CONFIRMATION_PAGE: {
    RCP_ZONE_A: 'RCP_ZONE_A',
  },

  STORE_PURCHASE_HISTORY_PAGE: {
    SPH_ZONE_A: 'SPH_ZONE_A',
    SPH_ZONE_B: 'SPH_ZONE_B',
  },

  STORE_PURCHASE_DETAIL_PAGE: {
    SPD_ZONE_A: 'SPD_ZONE_A',
    SPD_ZONE_B: 'SPD_ZONE_B',
  },

};
